import { BaseForm } from 'craftable';
import FormMixin from '../Mixin';
// const FormMixin = {
//     methods: {
//         formatRupiah(angkanya, prefix)
//         {
//             let rev = parseInt(angkanya, 10).toString().split('').reverse().join('');
//             let rev2 = '';
//             for (let j = 0; j < rev.length; j++) {
//                 rev2 += rev[j];
//                 if ((j + 1) % 3 === 0 && j != (rev.length - 1)) {
//                 rev2 += '.';
//                 }
//             }
//             prefix = prefix ?(prefix):"" 
//             return prefix+rev2.split('').reverse().join('');
//         },
//         formatDate(dateString, originFormat, toFormat)
//         {
//             originFormat = originFormat || "YYYY-MM-DD hh:mm:ss"
//             toFormat = toFormat || "DD/MM/YYYY HH:mm:ss"
//             const momentObj = moment(dateString, originFormat);
//             if(momentObj.isValid()){
//                 return momentObj.format(toFormat)
//             }
//             return ""
//         }
       
//     }
// }

export default {
	mixins: [BaseForm, FormMixin]
};